<nz-card>
  <h2 class="no-margin-top">Delivery Information</h2>

  <ng-container *ngIf="selectedVariant.deliveryFormat === 'eBook' || selectedVariant.deliveryFormat === 'eLearning' || selectedVariant.deliveryFormat === 'video' || selectedVariant.deliveryFormat === 'slides'">
    <p>This product is delivered as a <a target="_blank" rel="noopener noreferrer" [href]="getVouchersExplanationUrl">voucher</a>. After ordering, the voucher(s) will be available in your Dashboard (myLeapest). You can assign the vouchers directly to your learners, via the <a target="_blank" rel="noopener noreferrer" [href]="getVouchersManagementUrl">Voucher Management</a> functionality, or using the <a target="_blank" rel="noopener noreferrer" [href]="getClassManagementUrl">Class Management</a> functionality, to assign multiple vouchers to a group. Your learners will be then able to access and use the materials via your own <a target="_blank" rel="noopener noreferrer" [href]="getBrandedPortal">(branded) Learning Portal.</a></p>

  </ng-container>

  <ng-container *ngIf="selectedVariant.deliveryFormat === 'Print-License'">
    <p>This product is delivered as a license. You will be able to provide the email for the person/company responsible for the print.</p>
    <p>Each license can only be used once and it will be consumed after a printing attempt.</p><br>
    <p>We recommend using professional print shops as the materials are of high volume and might be too demanding for a standard office printer. Together with the print license, the person will receive instructions on how to install and use the software required to access the locked files.</p>
    <p><b>Note:</b> Leapest uses the Locklizard for file protection. In order to open the protected files, you need to install a Safeguard Security Viewer. Instructions on how to do that will be provided in the email.</p>
    <p>If there are any digital contents associated with this product, they will be delivered as <a [href]="getVouchersExplanationUrl">vouchers</a>, you can see if this is the case under this page’s contents tab.</p>
  </ng-container>

  <ng-container *ngIf="selectedDeliveryFormatKey === 'Printed'">
    <p>This product is delivered as printed materials. On checkout, you’ll be asked to choose from three shipping methods: economy (2 - 6 days), standard ( 2- 4 days) and express (1 - 3 days) with the cost indication. Once the items have been printed and shipped, you will receive a notification by email. The items will be sent to your shipping address, selected on checkout.</p>
    <p>If there are any digital contents associated with this product, they will be delivered as vouchers, you can see if this is the case under this page’s contents tab.</p>
  </ng-container>

  <ng-container *ngIf="selectedDeliveryFormatKey === 'paperback'">
    <p>This item will be shipped by <b>{{product.seller.displayName}}</b>. Depending on the shipping policy of the seller, you may be able to choose from different shipping methods on Checkout. Once the items have been shipped, you will receive a notification by email. The items will be sent to your shipping address, selected on checkout.</p>
    </ng-container>

  <ng-container *ngIf="selectedDeliveryFormatKey === 'Webcam-Proctor-Online-Exam' || selectedDeliveryFormatKey === 'AI-Proctored-Exam'">
    <p>This product is delivered as a <a target="_blank" rel="noopener noreferrer" [href]="getVouchersExplanationUrl">voucher</a>. After ordering, the voucher(s) will be available in your Dashboard (myLeapest). You can assign the vouchers directly to your learners, via the <a target="_blank" rel="noopener noreferrer" [href]="getVouchersManagementUrl">Voucher Management</a> functionality, or using the <a target="_blank" rel="noopener noreferrer" [href]="getClassManagementUrl">Class Management</a> functionality, to assign multiple vouchers to a group.After being assigned to your learners, the Seller will then make the necessary arrangements and to communicate with you and the learners so they can select a date to schedule the exam. Please be aware that requests to schedule exams need to be submitted in advance.</p>
    <p>For more information about exams, please refer to <a target="_blank" rel="noopener noreferrer" [href]="allAboutExamsUrl">this article.</a></p>
  </ng-container>

  <ng-container *ngIf="selectedDeliveryFormatKey === 'Online-Exam' || selectedDeliveryFormatKey === 'Paper-Exam'">
    <p>This product is delivered as a <a target="_blank" rel="noopener noreferrer" [href]="getVouchersExplanationUrl">voucher</a>. After ordering, the voucher(s) will be available in your Dashboard (myLeapest). You can assign the vouchers directly to your learners, via the <a target="_blank" rel="noopener noreferrer" [href]="getVouchersManagementUrl">Voucher Management</a> functionality, or using the <a target="_blank" rel="noopener noreferrer" [href]="getClassManagementUrl">Class Management</a> functionality, to assign multiple vouchers to a group. After being assigned to your learners, the Seller will then make the necessary arrangements and schedule the exams based on the information you provided. Please be aware that requests to schedule exams need to be submitted in advance.</p>
    <p>For more information about exams, please refer to <a target="_blank" rel="noopener noreferrer" [href]="allAboutExamsUrl">this article.</a></p>
  </ng-container>

  <h2>Product Specifications</h2>

  <div *ngIf="type">
    <h3 class="no-margin-top">Product Type</h3>
    <p>{{type}}</p>
  </div>

  <div *ngIf="selectedVariant?.deliveryFormatConfig">
    <h3>Delivery Format</h3>
    <p>{{selectedVariant.deliveryFormatConfig?.configValue}}</p>
  </div>

  <div *ngIf="isProductExamType">
    <h3>Certificate Type</h3>
    <p>{{selectedVariant.certificateTypeConfig?.configValue}}</p>
  </div>

  <div *ngIf="selectedVariant?.languageConfig">
    <h3>Language</h3>
    <p>{{selectedVariant.languageConfig?.configValue}}</p>
  </div>

  <div *ngIf="level">
    <h3>Level</h3>
    <p>{{ level }}</p>
  </div>

  <div *ngIf="courseInfo?.duration || examInfo?.duration">
    <h3>Duration</h3>
    <p *ngIf="!isProductExamType">{{ durationValue }}</p>
    <p *ngIf="isProductExamType">{{ durationValue }}</p>
  </div>

  <div *ngIf="accessDuration && accessDurationType">
    <h3>Access Duration</h3>
    <p>
      {{accessDuration}} {{accessDurationType}}
      <span nzTooltipTitle='Once the item has been accessed for the first time, the user will have access to the item for {{accessDuration}} {{accessDurationType}}.'
            nzTooltipPlacement="right"
            nz-tooltip>
        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             overflow="visible" preserveAspectRatio="none" viewBox="0 0 514 514" width="12" height="12"><g
                transform="translate(1, 1)"><path
                d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                vector-effect="non-scaling-stroke" style="fill: rgb(142, 143, 166);"/></g></svg>
      </span>
    </p>
  </div>
  <div *ngIf="countryOfOrigin?.length">
    <h3>Country of Origin (Products)</h3>
    <p>{{countryOfOrigin.join(', ')}}</p>
  </div>

  <div *ngIf="courseInfo?.prerequisites || instructions?.prerequisites">
    <h3>Prerequisites</h3>
    <p *ngIf="!isProductExamType" [innerHTML]="courseInfo.prerequisites"></p>
    <p *ngIf="isProductExamType" [innerHTML]="instructions.prerequisites"></p>
  </div>

  <div *ngIf="isProductExamType || type === 'Assessment'">

    <div *ngIf="examInfo.fulfillment">
      <h3>Fulfilled by</h3>
      <p>{{ examInfo.fulfillment }}</p>
    </div>

    <div *ngIf="examInfo.questionFormat">
      <h3>Question Format</h3>
      <p>{{ examInfo.questionFormat }}</p>
    </div>

    <div *ngIf="examInfo.planning">
      <h3>Planning</h3>
      <p [innerHTML]="examInfo.planning"></p>
    </div>

    <div *ngIf="examInfo.passGrade">
      <h3>Pass Grade</h3>
      <p>{{ examInfo.passGrade }}</p>
    </div>

    <div *ngIf="examInfo.passGradeInstructors">
      <h3>Pass Grade Instructors</h3>
      <p>{{ examInfo.passGradeInstructors }}</p>
    </div>

    <h3>Open Book Exam</h3>
    <p>{{ examInfo.openBookExam ? 'Yes' : 'No'}}</p>

    <div *ngIf="examInfo.questions">
      <h3>No. of Questions</h3>
      <p>{{ examInfo.questions }}</p>
    </div>

    <div *ngIf="examInfo.extraTime">
      <h3>Extra Time</h3>
      <p>{{ examInfo.extraTime}}</p>
    </div>
  </div>

</nz-card>
